import { SimpleMapper } from './simple.mapper';
import IProcessesStatisticDTO = ZoningAPI.IProcessesStatisticDTO;
import { IProcessesStatistic } from '../interfaces/processes-statistic.interface';
import { ProcessesStatistic } from '../models/processes-statistic';

export class ProcessesStatisticMapper extends SimpleMapper<IProcessesStatistic, IProcessesStatisticDTO> {
    fromDTOFields = [
        'processesCount',
        'runningThreadsCount',
        'maxThreadsCount',
        'availableThreadsCount',
        'activeProcessesCount',
        'allowedThreadsCount',
        'threadsUpdateTime',
        'finishingProcessesCount',
        'finishingThreadsCount',
        'alreadyReservedThreadsCount',
        'availableToReserveThreadsCount',
        'threadsIncreaseSchedulerActive',
        'processesSchedulerActive'
    ];

    protected entityConstructor = ProcessesStatistic;
}
